export default function() {
  this.$el = $('#invite_instructor');
  this.$nameSearchEl = $('#instructor_search_first_name, #instructor_search_last_name');
  this.$emailSearchEl = $('#instructor_search_email');

  this.selectedInstructor = ko.observable({
    first_name: ko.observable(),
    last_name: ko.observable(),
    email: ko.observable(),
    external_id: ko.observable(),
    role: ko.observable('Instructor')
  });

  this.initUI = () => this.initTypeaheads()

  this.resetSelectedInstructor = () => {
    this.client_errors = ko.validation.group(
      this.selectedInstructor(),
      { deep: true }
    );

    this.selectedInstructor().first_name('');
    this.selectedInstructor().last_name('');
    this.selectedInstructor().email('');
    this.selectedInstructor().external_id('');

    this.client_errors.showAllMessages(false);
  };

  this.initSearchEngine = type => {
    const instructorSearch = new Bloodhound({
      datumTokenizer: Bloodhound.tokenizers.obj.whitespace(type),
      queryTokenizer: Bloodhound.tokenizers.whitespace,
      limit: 5,

      remote: {
        url: Kadenze.Routes.instructors_list_path({ q: '%QUERY', type }),

        filter: instructors => {
          return instructors.map(instructor => {
            return {
              name: instructor.full_name,
              first_name: instructor.first_name,
              last_name: instructor.last_name,
              email: instructor.email.trim(),
              external_id: instructor.external_id
            };
          });
        },

        ajax: {
          dataType: 'json',
          contentType: 'application/json',
          beforeSend: () => $('.status_indicator').html('Searching...'),
          complete: () => $('.status_indicator').html(''),
        }
      }
    });

    instructorSearch.initialize();

    return instructorSearch;
  };

  this.initTypeahead = ($element, key) => {
    const searchEngine = this.initSearchEngine(key);

    $element.typeahead({
      hint: false,
      highlight: true,
      minLength: 1
    },

    {
      name: 'instructors',
      displayKey: key,
      source: searchEngine.ttAdapter()
    });

    $element.on('typeahead:selected', this.resultsSelected);
  };

  this.resultsSelected = (obj, datum) => {
    this.selectedInstructor().first_name(datum.first_name);
    this.selectedInstructor().last_name(datum.last_name);
    this.selectedInstructor().email(datum.email);
    this.selectedInstructor().external_id(datum.external_id);
  };

  this.initTypeaheads = () => {
    this.initTypeahead(this.$nameSearchEl, 'name');
    this.initTypeahead(this.$emailSearchEl, 'email');
  };

  this.inviteInstructor = (item, event) => {
    this.client_errors = ko.validation.group(
      this.selectedInstructor(),
      { deep: true }
    );

    if (this.client_errors().length) {
      this.client_errors.showAllMessages();
    } else {
      this.sendInvitation();
    }
  };

  this.sendInvitation = () => {
    const url = Kadenze.Routes.course_invite_instructor_path(this.course_id);
    const method = 'POST';

    const data = {
      instructor: ko.mapping.toJS(this.selectedInstructor())
    };

    Kadenze.UIUtil.makeRequest(
      url,
      method,
      data,
      this.$el,
      null,
      (data, textStatus, xhr) => {
        Kadenze.UIUtil.showNotice($('#notice_container'), data, 5000);
        this.resetSelectedInstructor();
      },

      (xhr, textStatus, errorThrown) => {
        Kadenze.UIUtil.showNotice($('#notice_container'), xhr.responseJSON, 5000);
      }
    );
  };

  (() => {
    this.course_id = $('#course_id').val();

    const role = Kadenze.Util.getParameterByName('role');

    if (role)
      this.selectedInstructor().role(role.replace('+', ' '));

  })();
}

